import { z } from 'zod';
const uuid = z.string().uuid();
// ─── Create file schemas (discriminated by kind) ────────────────
const description = z.string().max(2000).optional();
export const createUploadFileSchema = z.object({
    kind: z.literal('upload'),
    name: z.string().min(1).max(255),
    description,
    content_type: z.string().min(1),
    parent_id: uuid.optional(),
    tags: z.array(z.string().min(1).max(50)).max(20).optional(),
});
export const createUrlFileSchema = z.object({
    kind: z.literal('url'),
    name: z.string().min(1).max(255),
    description,
    url: z.string().url(),
    parent_id: uuid.optional(),
    tags: z.array(z.string().min(1).max(50)).max(20).optional(),
});
export const createFolderSchema = z.object({
    kind: z.literal('folder'),
    name: z.string().min(1).max(255),
    description,
    parent_id: uuid.optional(),
});
export const createFileSchema = z.discriminatedUnion('kind', [
    createUploadFileSchema,
    createUrlFileSchema,
    createFolderSchema,
]);
// ─── Update file schema ─────────────────────────────────────────
export const updateFileSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    description: z.string().max(2000).nullable().optional(),
    parent_id: uuid.nullable().optional(),
    /** Only meaningful for `url` files — the address the link points at. */
    url: z.string().url().optional(),
}).refine((data) => data.name !== undefined ||
    data.description !== undefined ||
    data.parent_id !== undefined ||
    data.url !== undefined, { message: 'At least one of name, description, parent_id, or url must be provided' });
// ─── New version schema ─────────────────────────────────────────
export const newVersionSchema = z.object({
    content_type: z.string().min(1),
    comment: z.string().min(1).max(500),
});
// ─── Tags schema ────────────────────────────────────────────────
export const addTagsSchema = z.object({
    tags: z.array(z.string().min(1).max(50)).min(1).max(20),
});
//# sourceMappingURL=files.js.map